export default {
  about: {
    title: "About Us",
    section1_title: "Why we decided to launch Nesto",
    section1_p1:
      "For most of us, buying a home will be the most important purchase we will ever make. Yet, due to the complexity of the process, we often settle for sub-optimal mortgages, leaving thousands of dollars of potential savings on the table.",
    section1_p2: "The current mortgage landscape is broken in many ways:",
    section1_p3:
      "• There is a <strong>lack of transparency on products and rates</strong> - it becomes a full-time job for customers to access rates and negotiate with financial institutions ",
    section1_p4:
      "• <strong>Banks offering higher rates</strong>, in hopes of converting captive clients",
    section1_p5:
      "• <strong>Mortgage Brokers with conflicting interests</strong>: pushing for the best deal, while maximizing their commission (e.g., favor selected lenders to hit their volume targets)",
    section1_p6:
      "• Overall, the application process is <strong>opaque, complex, time-consuming</strong> and <strong>stressful</strong>",
    section1_p7:
      "At <strong>Nesto</strong>, we believe we can solve these issues by providing you with a <strong>truly transparent mortgage solution</strong> that deals with the challenges our industry is facing.",

    section2_title: "Our Vision",
    section2_p1:
      "Ultimately, Nesto’s Vision is to give every Canadian access to home ownership.",
    section2_p2:
      "We support our Vision by <strong>providing our customers with the best mortgage deal possible</strong> for the most important financial decision of their life.",

    section3_title: "Our Solution",
    section3_p1: "We believe in true transparency",
    section3_p2:
      "Accessing accurate <strong>quotes from 20+ trusted financial institutions</strong>. Our smart technology will save you hours of online research, phone calls, and branch visits",
    section3_p3:
      "<strong>Independent Mortgage Brokers that work for you</strong>, not the banks. Your dedicated Mortgage Broker will guide you in the selection of the right product for your own situation. In selecting the best deal, they’ll tell you how much the bank is making, and what’s in it for us.",
    section3_p4:
      "Managing the complexity of the application for you. Your Mortgage Broker will <strong>handle your application from start to finish</strong>, keeping you updated along the way. Our smart technology simplifies the application, and accelerates the process.",
    section3_p5:
      "In short, <strong>Nesto will save you money</strong> by offering you an <strong>exhaustive list of deals</strong>, providing <strong>independent advice</strong> from experienced mortgage professionals, and <strong>streamlining the application</strong>."
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/about.js